import { DateCell, TableCell, TextCell } from '@/components/Table'
import { ImageCellContent } from '@/components/Table/TableCell'
import type { Id } from '@/infra/id'

interface ClientUserManagementNameCellWithIndicatorProps {
  title?: string | null
  image?: string | null
  imageFallback?: string | null
  size?: number
  minWidth?: number
  noPadding?: boolean
  testId?: string
  online?: boolean
}

function ClientUserManagementNameCellWithIndicator({
  title,
  image,
  imageFallback,
  size,
  minWidth,
  noPadding,
  testId,
  online,
}: ClientUserManagementNameCellWithIndicatorProps) {
  return (
    <TableCell testId={testId}>
      <ImageCellContent
        title={title}
        image={image}
        size={size}
        imageFallback={imageFallback}
        minWidth={minWidth}
        noPadding={noPadding}
        online={online}
      />
    </TableCell>
  )
}

export interface ClientUserManagementTableRowProps {
  publicId: Id
  displayName: string
  online: boolean
  email: string
  lastSeen: Date | null
  dateCreated: Date
}

export function ClientUserManagementTableRow({
  publicId,
  displayName,
  online,
  email,
  lastSeen,
  dateCreated,
}: ClientUserManagementTableRowProps) {
  return (
    <>
      <ClientUserManagementNameCellWithIndicator
        title={displayName}
        testId={`user-management-table-row-user-${publicId}`}
        online={online}
      />

      <TextCell>{email}</TextCell>

      <DateCell date={lastSeen} />

      <DateCell date={dateCreated} />
    </>
  )
}
